export default __webpack_public_path__ + "static/media/social.be46260c.svg";